import { select, put, takeLatest } from 'redux-saga/effects';
import { privateCall } from './api.saga';
import { usersActions } from '../reducers/users.reducer';
import { normalizeUsers } from '../normalizer/users.normalizer';

function* getAllProfiles() {
	try {
		const endpoint = yield select(s => s.config.endpoints.userProfiles.getAllProfiles);
		const { users } = yield privateCall({ endpoint, method: 'get' });

		yield put(usersActions.getAllProfilesComplete(normalizeUsers(users)));
	} catch (e) {}
}

export default function* userProfilesSaga() {
	yield takeLatest(usersActions.getAllProfiles, getAllProfiles);
}
